import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import LocationDialog from "pages/inventory/location/LocationDialog";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocationsThunk,
  locationSelector,
  deleteLocationThunk,
} from "store/reducers/inventory/locationSlice";
import AssignLocationAdminToLocationDialog from "./operations/AssignLocationAdminToLocationDialog";

const LocationList = () => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  useEffect(() => {
    dispatch(getLocationsThunk());
  }, []);
  const locations = useSelector(locationSelector.selectAll);

  const [currentItem, setCurrentItem] = React.useState(null);
  const [openLocationUpdate, setOpenLocationUpdate] = React.useState(false);
  const [openLocationAssign, setOpenLocationAssign] = React.useState(false);

  const handleLocationClose = () => {
    setOpenLocationUpdate(false);
  };
  const handleEditClick = (item) => {
    setCurrentItem(item);
    setOpenLocationUpdate(true);
  };
  const handleAssignAdminClick = (item) => {
    setCurrentItem(item);
    setOpenLocationAssign(true);
  };
  const onDelete = (item) => {
    dispatch(deleteLocationThunk(item.id));
  };
  const { loading, success, errorMessage, error } = useSelector(
    (state) => state.location
  );
  return (
    <Box>
      <Box
        sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
        padding={1}
      >
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ minWidth: 100 }}>
                  {isSmallScreen ? "Name" : "Location name"}
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 120 }}>
                  {isSmallScreen ? "Desc" : "Description"}
                </TableCell>
                <TableCell align="center">GST</TableCell>
                <TableCell align="center" sx={{ minWidth: 100 }}>
                  VA No
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 100 }}>
                  Maintain stock
                </TableCell>
                <TableCell align="center" sx={{ minWidth: 100 }}>
                  Location admin
                </TableCell>
                <TableCell sx={{ width: 60 }}>&nbsp;</TableCell>
                <TableCell sx={{ width: 60 }}>&nbsp;</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {locations.map((location) => (
                <TableRow
                  key={location.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {location.name}
                  </TableCell>
                  <TableCell align="center">
                    {location.desc.length > 0 ? location.desc : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {location.gst.length > 0 ? location.gst : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {location.va_no.length > 0 ? location.va_no : "-"}
                  </TableCell>

                  <TableCell align="center">
                    {location.maintain_stock ? "True" : "False"}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="text"
                      onClick={() => handleAssignAdminClick(location)}
                    >
                      {location.location_admin
                        ? `${location.location_admin.first_name} ${location.location_admin.last_name}`
                        : "Add admin"}
                    </Button>
                  </TableCell>

                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      onClick={() => handleEditClick(location)}
                    >
                      Edit
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <LoadingButton
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        onDelete(location);
                      }}
                      loading={loading.delete === location.id}
                    >
                      Delete
                    </LoadingButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <LocationDialog
        open={openLocationUpdate}
        handleClose={handleLocationClose}
        location={currentItem}
      />
      {openLocationAssign && (
        <AssignLocationAdminToLocationDialog
          open={openLocationAssign}
          handleClose={setOpenLocationAssign}
          location_id={currentItem?.id}
        />
      )}
    </Box>
  );
};

export default LocationList;
